import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

import swal from 'sweetalert2';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent extends ComponentBase implements OnInit {

  private id: string

  constructor() {
      super();
  }

  ngOnInit() {
    this.id = sessionStorage.getItem("_ins");
  }

  getDynamicIconClass(): string {
    const iconOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "icon");

    if(iconOpt) {
      return `fa-${iconOpt.value} icon-large`;  
    } else {
      return "";
    }
  }

  onClick() {
    let targetOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "target")

    let targetValue: string
    let targetType = "_blank";

    const targetTypeOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "targetType".toLowerCase());

    if(targetTypeOpt) {
      if(!targetTypeOpt.value.startsWith("_")) {
        targetType = `_${targetTypeOpt.value}`
      } else {
        targetType = targetTypeOpt.value;
      }
    }

    if(targetOpt) {
      targetValue = targetOpt.value
    } else {
      targetValue = this.attribute.value
    }

    if(targetValue.startsWith("http")) {
      window.open(targetValue, targetType);
    } else {
      this.emit({ name: "turn", data: targetValue })
    }
  }

  getTitle(): string {
    let titleOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.attribute.key
  }
}
